export const invertedMessages = {
  High: 'APPROVAL.CONFIDENCE.HIGH',
  Low: 'APPROVAL.CONFIDENCE.LOW',
  Medium: 'APPROVAL.CONFIDENCE.MEDIUM',
};
